import { Sparkles } from "lucide-react";

/**
 * Phase 5 — Compliance badge rendered wherever AI-generated text is shown.
 * The text is intentionally cautious: "AI-drafted — please review before sending."
 *
 * Usage:
 *   <AIDisclosureBadge />               // standalone pill
 *   <AIDisclosureBadge inline />        // smaller chip for inline placement
 *   <AIDisclosureBadge tone="warning"/> // amber colour when LLM fell back
 */
export default function AIDisclosureBadge({
  inline = false,
  tone = "default",
  label,
  testId = "ai-disclosure-badge",
}) {
  const isWarning = tone === "warning";
  const baseStyle = isWarning
    ? {
        background: "rgba(251,191,36,0.10)",
        border: "1px solid rgba(251,191,36,0.45)",
        color: "#FBBF24",
      }
    : {
        background: "rgba(167,139,250,0.10)",
        border: "1px solid rgba(167,139,250,0.45)",
        color: "#C4B5FD",
      };

  const text =
    label ||
    (isWarning
      ? "AI assist unavailable — using template fallback"
      : "AI-drafted — please review before sending");

  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${
        inline ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs"
      }`}
      style={baseStyle}
    >
      <Sparkles className={inline ? "w-3 h-3" : "w-3.5 h-3.5"} />
      {text}
    </span>
  );
}
